module.exports = __webpack_public_path__ + "img/华融化学.d99df943.png";